import {atom} from 'recoil';

const activeVoiceIdAtom = atom({
  key: '@voice_player_atom',
  default: <string>'',
});

export default activeVoiceIdAtom;
